import React, { useState } from "react";
import { Button, Col, Collapse, Form, Input, message, Row, Spin } from "antd";
import axios from "axios";
import { uniqueId } from "lodash";
import { resetPasswordRoute } from "../../lib/rolesRoutes";
import { hasAccess } from "../../hasAccess";
import {
  MENU_USER_USERMANAGEMENT_WRITE,
  USER_PASSWORD_FORCE_CHANGE,
} from "../../../../lib/const/permissions";
import "./UserResetPassword.less";

export const UserResetPassword = (props) => {
  const { user, requirements, requirementsLoading } = props;

  const [changePasswordForm] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(""); // Состояние для ошибки пароля

  const onReset = () => {
    setPasswordError("");
    changePasswordForm.resetFields();
  };

  const onChangePassword = async ({ newPassword }) => {
    setIsLoading(true);

    try {
      const response = axios.put(resetPasswordRoute(user.id), { newPassword });

      const { status } = await response;
      if (status === 200 || status === 204) {
        message.destroy();
        message.success({
          content: "Пароль успешно изменен",
          duration: 2,
        });
        onReset();
      }
    } catch (e) {
      const errorMessage = e?.response?.data?.message;

      if (errorMessage) {
        // Проверяем, содержит ли сообщение хотя бы одну английскую букву
        const containsEnglishLetter = /[a-zA-Z]/.test(errorMessage);
        if (containsEnglishLetter) {
          setPasswordError("Ошибка смены пароля");
        } else {
          setPasswordError(errorMessage || "Ошибка смены пароля");
        }
      } else {
        setPasswordError("Ошибка смены пароля");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const changePasswordValidator = () => {
    const { newPassword, confirmPassword } = changePasswordForm.getFieldsValue();

    if (!confirmPassword || confirmPassword === "") {
      return Promise.resolve();
    }

    return newPassword === confirmPassword ? Promise.resolve() : Promise.reject();
  };

  const changePasswordConfirmValidator = () => {
    const { newPassword, confirmPassword } = changePasswordForm.getFieldsValue();
    return newPassword === confirmPassword ? Promise.resolve() : Promise.reject();
  };

  const clsName = "user-reset-password-container";

  const getRenderChangePassword = () => {
    return (
      <div className={`${clsName}__changePassword`}>
        <Spin spinning={isLoading || requirementsLoading}>
          <Form layout="vertical" onFinish={onChangePassword} form={changePasswordForm}>
            <Form.Item
              label="Введите новый пароль"
              name="newPassword"
              initialValue={undefined}
              dependencies={["confirmPassword"]}
              className={`${clsName}__formItem`}
              rules={[
                {
                  required: true,
                  message: "",
                  validator: changePasswordValidator,
                },
                {
                  required: true,
                  message: "",
                },
              ]}
              validateStatus={passwordError ? "error" : undefined}
            >
              <Input.Password onChange={() => setPasswordError("")} />
            </Form.Item>

            <Form.Item
              label="Подтвердите пароль"
              name="confirmPassword"
              initialValue={undefined}
              dependencies={["newPassword"]}
              className={`${clsName}__formItem__last`}
              rules={[
                {
                  required: true,
                  message: "",
                },
                {
                  required: true,
                  message: "",
                  validator: changePasswordConfirmValidator,
                },
              ]}
              validateStatus={passwordError ? "error" : undefined}
              help={passwordError} // Показываем сообщение об ошибке
            >
              <Input.Password
                onChange={() => {
                  setPasswordError("");
                  changePasswordForm.validateFields(["newPassword"]);
                }}
              />
            </Form.Item>

            <Row className={`${clsName}__requirements`}>
              {requirements && requirements?.description?.length > 0
                ? requirements.description.map((item) => (
                    <Col span={24} className="requirementsItem" key={uniqueId()}>
                      <span className="requirementsItemDots">•</span>
                      {item}
                    </Col>
                  ))
                : null}
            </Row>

            <Form.Item>
              <Button className={`${clsName}__btn`} htmlType="reset" onClick={onReset}>
                Отмена
              </Button>
              <Button className={`${clsName}__btn`} type="primary" htmlType="submit">
                Сохранить
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    );
  };

  return (
    <div className={clsName}>
      {user &&
        user?.userType !== "external" &&
        hasAccess(USER_PASSWORD_FORCE_CHANGE) &&
        hasAccess(MENU_USER_USERMANAGEMENT_WRITE) && (
          <Collapse
            expandIconPosition="right"
            defaultActiveKey="0"
            style={{ border: "1px solid #f0f0f0" }}
            destroyInactivePanel
          >
            <Collapse.Panel
              style={{ borderBottom: "none" }}
              header={<div style={{ paddingLeft: 24 }}>Смена пароля</div>}
              key="1"
            >
              {getRenderChangePassword()}
            </Collapse.Panel>
          </Collapse>
        )}
    </div>
  );
};
